(function(){
  var TOAST_KEY = 'fwbs_app_toast_dismissed';
  if (sessionStorage.getItem(TOAST_KEY)) return;

  function injectToast() {
    var css = document.createElement('style');
    css.textContent = ''
      + '.fwbs-toast-overlay{position:fixed;bottom:24px;right:24px;z-index:9999;pointer-events:none;font-family:Barlow,sans-serif;}'
      + '.fwbs-toast-overlay *{box-sizing:border-box;margin:0;padding:0;}'
      + '.fwbs-toast{pointer-events:auto;position:relative;width:380px;max-width:calc(100vw - 32px);background:rgba(15,15,15,0.92);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border:1px solid rgba(255,26,26,0.25);border-radius:12px;box-shadow:0 20px 60px rgba(0,0,0,0.5),0 0 40px rgba(204,0,0,0.08);overflow:hidden;transform:translateY(120%);opacity:0;transition:transform 0.5s cubic-bezier(0.16,1,0.3,1),opacity 0.4s ease;}'
      + '.fwbs-toast--visible{transform:translateY(0)!important;opacity:1!important;}'
      + '.fwbs-toast--hiding{transform:translateY(120%)!important;opacity:0!important;}'
      + '.fwbs-toast-accent{height:3px;background:linear-gradient(90deg,#cc0000,#ff1a1a,#cc0000);background-size:200% 100%;animation:fwbsShimmer 3s ease-in-out infinite;}'
      + '@keyframes fwbsShimmer{0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}'
      + '.fwbs-toast-body{padding:20px 20px 18px;display:flex;gap:16px;align-items:flex-start;}'
      + '.fwbs-toast-icon{flex-shrink:0;width:44px;height:44px;border-radius:10px;overflow:hidden;}'
      + '.fwbs-toast-icon img{width:100%;height:100%;object-fit:cover;display:block;border-radius:10px;}'
      + '.fwbs-toast-text{flex:1;min-width:0;}'
      + '.fwbs-toast-label{display:inline-block;font-family:Barlow Condensed,sans-serif;font-size:10px;font-weight:700;letter-spacing:0.2em;text-transform:uppercase;color:#ff1a1a;margin-bottom:6px;}'
      + '.fwbs-toast-title{font-family:Bebas Neue,sans-serif;font-size:22px;line-height:1.1;color:#fff;margin-bottom:6px;}'
      + '.fwbs-toast-desc{font-size:13px;font-weight:300;line-height:1.5;color:#999;margin-bottom:16px;}'
      + '.fwbs-toast-actions{display:flex;align-items:center;gap:10px;}'
      + '.fwbs-toast-actions a{font-family:Barlow Condensed,sans-serif;font-size:12px;font-weight:700;letter-spacing:0.15em;text-transform:uppercase;color:#fff;background:#cc0000;padding:10px 22px;border-radius:4px;text-decoration:none;display:inline-block;line-height:1;transition:background 0.2s ease;}'
      + '.fwbs-toast-actions a:hover{background:#ff1a1a;}'
      + '.fwbs-toast-actions button{font-family:Barlow,sans-serif;font-size:12px;font-weight:400;color:#666;background:none;border:none;cursor:pointer;padding:8px 4px;transition:color 0.2s ease;line-height:1;}'
      + '.fwbs-toast-actions button:hover{color:#999;}'
      + '.fwbs-toast-close{position:absolute;top:12px;right:12px;width:28px;height:28px;background:rgba(255,255,255,0.06);border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.2s ease;padding:0;}'
      + '.fwbs-toast-close:hover{background:rgba(255,255,255,0.12);}'
      + '.fwbs-toast-close svg{width:14px;height:14px;stroke:#888;stroke-width:2;fill:none;}'
      + '@media(max-width:480px){.fwbs-toast-overlay{bottom:16px;right:16px;left:16px;}.fwbs-toast{width:100%;}.fwbs-toast-title{font-size:20px;}}';
    document.head.appendChild(css);

    var html = ''
      + '<div class="fwbs-toast-overlay" id="fwbsToastOverlay" style="display:none;">'
      + '<div class="fwbs-toast" id="fwbsToast">'
      + '<div class="fwbs-toast-accent"></div>'
      + '<button class="fwbs-toast-close" id="fwbsToastClose" aria-label="Close">'
      + '<svg viewBox="0 0 14 14"><line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/></svg>'
      + '</button>'
      + '<div class="fwbs-toast-body">'
      + '<div class="fwbs-toast-icon">'
      + '<img src="https://cdn.shopify.com/s/files/1/0686/6019/9615/files/icon.png?v=1776022966" alt="FW Barber Supply App">'
      + '</div>'
      + '<div class="fwbs-toast-text">'
      + '<span class="fwbs-toast-label">// Limited Time</span>'
      + '<div class="fwbs-toast-title">Get the FWBS App</div>'
      + '<p class="fwbs-toast-desc">Get 100 bonus reward points for downloading!</p>'
      + '<div class="fwbs-toast-actions">'
      + '<a href="https://apps.apple.com/us/app/fw-barber-supply/id6761860615" target="_blank" rel="noopener">Download Free</a>'
      + '<button id="fwbsToastDismissText">Not now</button>'
      + '</div>'
      + '</div>'
      + '</div>'
      + '</div>'
      + '</div>';

    document.body.insertAdjacentHTML('beforeend', html);

    var overlay = document.getElementById('fwbsToastOverlay');
    var toast = document.getElementById('fwbsToast');

    function dismiss() {
      toast.classList.remove('fwbs-toast--visible');
      toast.classList.add('fwbs-toast--hiding');
      sessionStorage.setItem(TOAST_KEY, '1');
      setTimeout(function(){ overlay.style.display = 'none'; }, 500);
    }

    document.getElementById('fwbsToastClose').addEventListener('click', dismiss);
    document.getElementById('fwbsToastDismissText').addEventListener('click', dismiss);

    overlay.style.display = 'block';
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        toast.classList.add('fwbs-toast--visible');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(injectToast, 3000); });
  } else {
    setTimeout(injectToast, 3000);
  }
})();